/* eslint-disable react/jsx-no-literals */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { Icon } from "@jutro/components";
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { BillingService,
} from 'gw-capability-billing';
import metadata from './BillingDocumentsTable.metadata.json5';
import styles from './BillingDocumentsTable.module.scss';

const renderFormattedCurrencyField = (item, index) => (
        <div className={styles.currencyContainer}>
            <CurrencyField
                id={`currency_${index}`}
                value={item}
                readOnly
                hideLabel
            />
        </div>
    );

const getFormattedCurrency = (item, index, property) => renderFormattedCurrencyField(item[property.id]);

const getCell = (item, index, property) => item[property.id];

function RecentAccountPaymentTable(props) {
    const {
        invoiceSummary,
        showPaidDate,
        showSelect,
        selectedDocYear
    } = props;

    const [filterInvoiceSummary,setFilterInvoiceSummary] = useState(invoiceSummary);

    useEffect(()=>{
        setFilterInvoiceSummary(invoiceSummary.filter((item)=>
           // eslint-disable-next-line eqeqeq
           selectedDocYear? moment(item?.dateModified).year() == selectedDocYear : true

        ))
    },[invoiceSummary, selectedDocYear])

    const getFormattedDate = useCallback((item, index, property) => moment(item[property.id]).format('MM/DD/YYYY'), []);

    const getPDF = (item, index) => (
            <button
                id={index}
                onClick={async(e) => {

                    e.preventDefault()

                    await BillingService.downloadbillingDocument(item.docUID,item.sessionID)
                    // const a = document.createElement("a");

                    // a.setAttribute("href", res);
                    // document.body.appendChild(a);
                    // a.click();
                }}


                style={{ display: "block" }}
                className={styles.PDFButton}
            >
                <Icon icon="cust-file-solid" />
                PDF
            </button>
        );

    const overrideProps = {
        tablePaymentScheduleDetail: {
            data: filterInvoiceSummary
        },
        tablePaymentScheduleDetailLastPaymentDate: {
            visible: showPaidDate
        },
        tablePaymentScheduleDetailPay: {
            visible: showSelect
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getFormattedDate,
            getFormattedCurrency,
            getCell,
            getPDF

        }
    };

    return <MetadataContent uiProps={metadata.componentContent} overrideProps={overrideProps} {...resolvers} />;
}

RecentAccountPaymentTable.propTypes = {
    invoiceSummary: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    selectedInvoices: PropTypes.arrayOf(PropTypes.string),
    onUpdateSelectedInvoices: PropTypes.func,
    showSelect: PropTypes.bool,
    showPaidDate: PropTypes.bool
};

RecentAccountPaymentTable.defaultProps = {
    selectedInvoices: [],
    onUpdateSelectedInvoices: undefined,
    showSelect: false,
    showPaidDate: false
};

export default RecentAccountPaymentTable;
